import LegalPage from './Legal';

export default LegalPage;
